export default __webpack_public_path__ + "static/ecoenclose-1ef630d3640430637b51acc65b2d6896.jpg";